import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import "./viewUserDetail.scss";
import BackBtn from "../../../../library/custom/backBtn/backBtn";
import { ORG_ID } from "../../../../constant/constant";
import { getLabel } from "../../../../utils/helper";

const ViewUserDetail = (props) => {
  const dataBack = { title: "Back", route: -1 };
  const products = props?.userData?.product || [];
  const hasSafety = products.some((p) => p.value === "Safety");
  const hasStormwater = products.some((p) => p.value === "Stormwater");
  const [safetyProductID, setSafetyProductID] = useState();
  const [stormWaterProductID, setStormWaterProductID] = useState();
  const [safetyDropDownData, setSafetyDropDownData] = useState([]);
  const [stormDropDownData, setStormDropDownData] = useState([]);

  const { jobTitles, userLocations, userDepartments, userBranches } =
    props?.dropDownData || {};

  const user = props?.userData || {};

  // 🧩 Map helpers
  const jobTitle = getLabel(jobTitles, user?.jobTitleId);
  const safetyDivision = getLabel(
    safetyDropDownData,
    user?.safetyDivisionIds?.[0]
  );
  const stormDivision = getLabel(
    stormDropDownData,
    user?.stormDivisionIds?.[0]
  );
  const location = getLabel(userLocations, user?.userLocationId);
  const department = getLabel(userDepartments, user?.departmentId);
  const branch = getLabel(userBranches, user?.branchId);

  // Fetch dropdown data
  useEffect(() => {
    if (!products?.length) return;

    if (hasSafety) {
      props?.getDropDowndata(1);
      setSafetyProductID(1);
    }
    if (hasStormwater) {
      props?.getDropDowndata(2);
      setStormWaterProductID(2);
    }
  }, [products]);

  useEffect(() => {
    if (!props?.dropDownData) return;
    const { divisons } = props?.dropDownData;

    if (safetyProductID === 1 && hasSafety) {
      setSafetyDropDownData(divisons || []);
    }
    if (stormWaterProductID === 2 && hasStormwater) {
      setStormDropDownData(divisons || []);
    }
  }, [props?.dropDownData, stormWaterProductID, safetyProductID]);

  return (
    <Grid container>
      <Grid item md={12} xs={12}>
        <div className="containerReportHistory">
          <h1 className="commonTitle">User Detail</h1>

          <div className="report-info">
            <p>
              <strong>First Name:</strong> {user?.firstname ?? "N/A"}
            </p>
            <p>
              <strong>Last Name:</strong> {user?.lastname ?? "N/A"}
            </p>
            <p>
              <strong>Email:</strong> {user?.email ?? "N/A"}
            </p>
            <p>
              <strong>Email Verified:</strong>{" "}
              {user?.isemailverified ? "Yes" : "No"}
            </p>
            <p>
              <strong>Phone:</strong> {user?.phonenumber ?? "N/A"}
            </p>
            <p>
              <strong>Phone Verified:</strong>{" "}
              {user?.isphonenumberverified ? "Yes" : "No"}
            </p>
            <p>
              <strong>Company:</strong> {user?.companyname ?? "N/A"}
            </p>
            <p>
              <strong>Job Title:</strong> {jobTitle}
            </p>
            <p>
              <strong>Hire Date:</strong> {user?.startDate ?? "N/A"}
            </p>
            <p>
              <strong>Service Type:</strong>{" "}
              {user?.product?.map((p, i) => (
                <span key={p.key}>
                  {p.value}
                  {i < user?.product.length - 1 && ", "}
                </span>
              ))}
            </p>
          </div>

          {/* Safety Section */}
          {hasSafety && (
            <div className="containerReportHistoryIn">
              <h1 className="commonTitle">Safety</h1>
              <div className="report-info">
                <p>
                  <strong>Division:</strong> {safetyDivision}
                </p>
                <p>
                  <strong>User Role:</strong>{" "}
                  {user?.safetyRoles?.length
                    ? user.safetyRoles.map((r, i) => (
                        <span key={r.key}>
                          {r.value}
                          {i < user.safetyRoles.length - 1 && ", "}
                        </span>
                      ))
                    : "N/A"}
                </p>

                {parseInt(ORG_ID()) === 50 && (
                  <>
                    <p>
                      <strong>Location:</strong> {location}
                    </p>
                    <p>
                      <strong>Department:</strong> {department}
                    </p>
                    <p>
                      <strong>Branch:</strong> {branch}
                    </p>
                    <p>
                      <strong>Supervisor First Name:</strong>{" "}
                      {user?.extPlatformSupervisorFname ?? "N/A"}
                    </p>
                    <p>
                      <strong>Supervisor Last Name:</strong>{" "}
                      {user?.extPlatformSupervisorLname ?? "N/A"}
                    </p>
                  </>
                )}
              </div>
            </div>
          )}

          {/* Stormwater Section */}
          {hasStormwater && (
            <div className="containerReportHistoryIn">
              <h1 className="commonTitle">Stormwater</h1>
              <div className="report-info">
                <p>
                  <strong>Certification Number:</strong>{" "}
                  {user?.certificationNumber ?? "N/A"}
                </p>
                <p>
                  <strong>Division:</strong> {stormDivision}
                </p>
                <p>
                  <strong>User Role:</strong>{" "}
                  {user?.stormRoles?.length
                    ? user.stormRoles.map((r, i) => (
                        <span key={r.key}>
                          {r.value}
                          {i < user.stormRoles.length - 1 && ", "}
                        </span>
                      ))
                    : "N/A"}
                </p>
              </div>
            </div>
          )}
        </div>

        <Grid item md={12} className="hideinprint">
          <BackBtn dataBack={dataBack} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ViewUserDetail;
